<template>
  <v-app id="app" dark  >
    <v-navigation-drawer
      v-model="drawer"
      temporary
      fixed
      right
      touchless
      disable-resize-watcher
    >
      <v-list dense>
        <v-list-tile 
          v-for="(link, index) in steps" 
          :key="index" 
          @click="goTo(index+1)"
          :class="{'title-active': isActive(index+1)}"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ link }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="#1d3f03" dark fixed app>
      <v-toolbar-title id="title" @click="goTo(0)">
        Warsztaty muzyczne
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn 
          flat 
          v-for="(link, index) in steps" 
          :key="index" 
          @click="goTo(index+1)"
          :class="{'step-active': isActive(index+1)}"
        >
          {{ link }}
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-content id="content">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <swiper :options="swiperOption" ref="mySwiper" class="swiper-box">
            <!-- slides -->
            <swiper-slide class="swiper-item"><Start /></swiper-slide>
            <swiper-slide class="swiper-item"><Warsztaty /></swiper-slide>
            <swiper-slide class="swiper-item"><Program /></swiper-slide>
            <swiper-slide class="swiper-item"><Prowadzacy /></swiper-slide>
            <swiper-slide class="swiper-item"><Podziekowania /></swiper-slide>
            <swiper-slide class="swiper-item"><Kontakt /></swiper-slide>
            <swiper-slide class="swiper-item"><Informacje @zapisy="goTo(6)" /></swiper-slide>
          </swiper>
          <v-btn
              fixed
              dark
              fab
              bottom
              right
              id="note"
            >
              <v-icon color="black">fas fa-music</v-icon>
            </v-btn>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Start from './slides/Start'
import Warsztaty from './slides/Warsztaty'
import Program from './slides/Program'
import Prowadzacy from './slides/Prowadzacy'
import Informacje from './slides/Informacje'
import Kontakt from './slides/Kontakt'
import Podziekowania from './slides/Podziekowania'

export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        touchAngle: 30,
        shortSwipes: false
      },
      steps: [
        'O WARSZTATACH',
        'PROGRAM',
        'PROWADZĄCY',
        'PODZIĘKOWANIA',
        'MIEJSCE',
        'ZAPISY',
        'INFORMACJE',
      ],
      drawer: null
    }
  },
  methods: {
    goTo: function(index) {
      if (index === 6) {
        const url = 'https://docs.google.com/forms/d/e/1FAIpQLSeBZjvh3wFZf9tnOiqGbu4BsAj3hm26Cj6Tbo8xaEsO71IF3g/viewform'
        let win = window.open(url, '_blank')
        win.focus()
        return
      }
      if (index > 6 ) {
        index--
      }
      this.swiper.slideTo(index, 1000, false)
      this.drawer = false
    },
    isActive: function(index) {
      if (undefined === this.$refs.mySwiper) {
        return false
      }
      
      let correction = this.swiper.activeIndex < 6 ? 0 : 1;
      return this.swiper.activeIndex + correction === index
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  components:{
    Start,
    Warsztaty,
    Program,
    Prowadzacy,
    Informacje,
    Kontakt,
    Podziekowania
  }
}
</script>

<style>
  #app {
    background: #A40427;
  }
  #title {
    cursor: pointer;
  }
  #note {
    background: radial-gradient(ellipse at center, #b9a407 0%,#fcea46 65%,#fefcea 100%);
  }
  @keyframes ring {
    0%{transform:rotate(-15deg)}
    3%{transform:rotate(15deg)}
    6%{transform:rotate(-18deg)}
    9%{transform:rotate(18deg)}
    12%{transform:rotate(-22deg)}
    15%{transform:rotate(22deg)}
    18%{transform:rotate(-18deg)}
    21%{transform:rotate(18deg)}
    24%{transform:rotate(-12deg)}
    27%{transform:rotate(12deg)}
    30%,100%{transform:rotate(0deg)}
  }
  #note i.v-icon {
    animation: ring 3s ease infinite;
  }
  .title-active {
    background-color: #1d3f03;
  }
  .v-content__wrap {
    background-image: url('assets/tree.png');
    background-repeat: repeat-x;
  }
  .swiper-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  .swiper-item {
    height: 100%;
    text-align: center;
    font-size: 18px ;
  }
  .step-active::before {
    background-color: white;
    opacity: .16
  }
  .swiper-item > div {
    padding: 60px 0 0 0;
  }
</style>